import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PayBridge } from '@apis/index'
import {
  Container,
  ContactLink,
  IconWrapper,
  Message,
  Meta,
  RetryButton,
  Title,
} from './style'

// Isolated cancel/failure page for PayBridge checkout sessions. PayBridge
// redirects here (cancelUrl) when the customer cancels or the payment fails.
const PayBridgeFailure = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const sessionId = queryParams.get('session_id')
  const status = queryParams.get('status')

  useEffect(() => {
    if (!sessionId) return
    PayBridge.syncSession({ id: sessionId }).catch((error) => console.error(error))
  }, [sessionId])

  return (
    <Container>
      <IconWrapper>
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
          />
        </svg>
      </IconWrapper>
      <Title>{status === 'cancelled' ? 'Payment Cancelled' : 'Payment Failed'}</Title>
      <Message>
        {status === 'cancelled'
          ? 'You cancelled the payment before it was completed. No amount has been charged.'
          : "We couldn't process your payment. Please try again or use a different payment method."}
      </Message>
      {sessionId && <Meta>Session: {sessionId}</Meta>}
      <RetryButton onClick={() => window.history.back()}>Try Again</RetryButton>
      <ContactLink href="/contact">Contact Support</ContactLink>
    </Container>
  )
}

export default PayBridgeFailure
